import * as React from 'react';
import HrList from '../../../components/HrList';
import Modal from '../../../components/Modal';
import { WithModal } from '../../../hoc/withModal';
import { getCurrentUser } from '../../../services/CurrentUser';

interface Props {
    children: (props: { openModal: () => void; closeModal: () => void }) => React.ReactNode;
}

export default function WithHrListSupportModal({ children }: Props) {
    return (
        <WithModal title="Need Support?" size="LG_WIDTH" renderModalContent={HrListSupport}>
            {children}
        </WithModal>
    );
}

export function HrListSupport() {
    const user = getCurrentUser();
    return (
        <>
            <p>
                If you need help using Small Improvements, please get in touch with your company's account
                administrators.
            </p>
            {!user.isGuest && <HrList includeAssistants={true} />}
        </>
    );
}

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export function HrListSupportModal({ isOpen, onClose }: ModalProps) {
    return (
        <Modal title="Need Support?" isOpen={isOpen} onClose={onClose} size="LG_WIDTH">
            <HrListSupport />
        </Modal>
    );
}
